const logg = (function (): (...args: any[]) => void {
	// Detect the environment variable for React (Vite) and Node
	const environment = import.meta.env?.VITE_ENV || 'DEV'; // || process.env.NODE_ENV

	// If the environment is "PROD", return an empty function
	if (environment === 'PROD') {
		return (): void => {}; // No-op in production
	}

	// Otherwise, return the normal console log function
	return (...args: any[]): void => {
		console.log(...args);
	};
})();

export { logg };
